import { createRoot } from "react-dom/client";
import { setBaseUrl } from "@workspace/api-client";
import App from "./App";
import { AppErrorBoundary } from "@/components/AppErrorBoundary";
import { getApiBaseUrl } from "@/lib/api-base-url";
import { initSentry } from "@/lib/sentry";
import { installTranslationDomGuard } from "@/lib/translation-dom-guard";
import { installAssetReloadHandler } from "@/lib/asset-reload";
import "./index.css";

initSentry();

// Both must run before the first render: the guard has to patch Node.prototype
// before React commits anything, and the preload handler has to be listening
// before the first lazy route starts resolving.
installTranslationDomGuard();
installAssetReloadHandler();

setBaseUrl(getApiBaseUrl() || null);

createRoot(document.getElementById("root")!).render(
	<AppErrorBoundary>
		<App />
	</AppErrorBoundary>
);
